(ns kyber.kyber-db.curriculum-learner)

(defn ->ident-key
  [{curriculum-uuid :curriculum/uuid
    user-uuid :user/uuid}]
  (str "curriculum-" curriculum-uuid "_learner-" user-uuid))

(def model
  {:ident-key ->ident-key})
